/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    return;
  }
  if (params.get('chat') !== '1') return;

  var opened = false;

  function openChat() {
    if (opened) return true;
    var el = document.querySelector('shopify-chat');
    if (!el) return false;
    try {
      el.setAttribute('view', 'chat');
      el.setAttribute('open', '');
      opened = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  if (openChat()) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (openChat() || tries > 60) clearInterval(timer);
  }, 250);
})();

/* Accessibility: keep keyboard focus out of carousel items that are aria-hidden (slideshow slides,
   scrolling product rows). Restores tabbability when the item becomes visible again. */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function sync(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    el.querySelectorAll(FOCUSABLE).forEach(function (f) {
      if (hidden) {
        if (!f.hasAttribute('data-a11y-tabindex')) {
          f.setAttribute('data-a11y-tabindex', f.hasAttribute('tabindex') ? f.getAttribute('tabindex') : '');
        }
        f.setAttribute('tabindex', '-1');
      } else if (f.hasAttribute('data-a11y-tabindex')) {
        var prev = f.getAttribute('data-a11y-tabindex');
        if (prev === '') { f.removeAttribute('tabindex'); } else { f.setAttribute('tabindex', prev); }
        f.removeAttribute('data-a11y-tabindex');
      }
    });
    if (hidden && el.matches(FOCUSABLE)) { el.setAttribute('tabindex', '-1'); }
    else if (!hidden && el.matches('a[href]') && el.getAttribute('tabindex') === '-1' && el.classList.contains('slideshow__slide')) { el.removeAttribute('tabindex'); }
  }
  function scan(root) {
    root.querySelectorAll('.slideshow__slide[aria-hidden], .product-item[aria-hidden], .flickity-slider [aria-hidden]').forEach(sync);
  }
  function init() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes') {
          var t = m.target;
          if (t.matches && t.matches('.slideshow__slide, .product-item, .flickity-slider > *')) sync(t);
        } else if (m.type === 'childList') {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
        }
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* Accessibility: the theme script toggles aria-expanded on the cart icon <div>, which is not a valid
   ARIA target. Mirror that state onto a CSS class (styled in css-variables.liquid) and drop the attribute. */
(function () {
  function fix(icon) {
    if (!icon.hasAttribute('aria-expanded')) return;
    icon.classList.toggle('is-expanded', icon.getAttribute('aria-expanded') === 'true');
    icon.removeAttribute('aria-expanded');
  }
  function init() {
    var icon = document.querySelector('.header__cart-icon');
    if (!icon) return;
    fix(icon);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { fix(icon); }).observe(icon, { attributes: true, attributeFilter: ['aria-expanded'] });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* Accessibility: Google's Merchant Center badge injects an <iframe> without a title. Add one. */
(function () {
  function label() {
    var f = document.getElementById('merchantwidgetiframe');
    if (f && !f.hasAttribute('title')) { f.setAttribute('title', 'Google Customer Reviews badge'); return true; }
    return !!f;
  }
  function init() {
    if (label() || !('MutationObserver' in window)) return;
    var obs = new MutationObserver(function () { if (label()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
